import React, { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_API_BASE_URL;

const BannerCarousel = () => {
  const [banners, setBanners] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadBanners();
  }, []);

  const loadBanners = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/banners`);
      const data = response.data;
      setBanners(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Failed to load banners:', error);
      setBanners([]);
    } finally {
      setLoading(false);
    }
  };

  // Auto slide every 10 seconds
  useEffect(() => {
    if (banners.length <= 1) return;
    const interval = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % banners.length);
    }, 10000);
    return () => clearInterval(interval);
  }, [banners.length]);

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  if (loading) return (
    <div className="w-full max-w-[1920px] mx-auto px-4 mb-8" aria-busy="true" aria-label="Загрузка баннера">
      <div className="w-full rounded-2xl bg-brand-surface" style={{ aspectRatio: '1920 / 560' }} />
    </div>
  );
  if (!banners.length) return null;
  const displayBanners = banners.filter(banner => banner.image);

  return (
    <div className="w-full max-w-[1920px] mx-auto px-4 mb-8">
      {/* Контейнер с фиксированным соотношением 1920:560 */}
      <div
        className="relative w-full overflow-hidden rounded-2xl"
        style={{ aspectRatio: '1920 / 560' }} // ← ключевая строка
      >
        {displayBanners.map((banner, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-opacity duration-700 ${
              index === currentIndex ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <img
              src={banner.image}
              alt={banner.title || 'Баннер'}
              className="w-full h-full object-cover"
              loading={index === 0 ? "eager" : "lazy"}
            />

          </div>
        ))}

        {/* Индикаторы */}
        {displayBanners.length > 1 && (
          <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2 z-10">
            {displayBanners.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`w-2 h-2 rounded-full transition-all ${
                  index === currentIndex 
                    ? 'bg-brand-surface w-6' 
                    : 'bg-brand-surface/50 hover:bg-brand-surface/70'
                }`}
                aria-label={`Слайд ${index + 1}`}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default BannerCarousel;